import { render, staticRenderFns } from "./roucePlay.vue?vue&type=template&id=1f95864e&scoped=true"
import script from "./roucePlay.vue?vue&type=script&lang=js"
export * from "./roucePlay.vue?vue&type=script&lang=js"
import style0 from "./roucePlay.vue?vue&type=style&index=0&id=1f95864e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95864e",
  null
  
)

export default component.exports